import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Navigation
    nav_home: 'Home',
    nav_about: 'About',
    nav_features: 'Features',
    nav_order: 'Order Now',
    
    // Hero Section
    hero_headline: 'Stop Guessing. Know Your Future.',
    hero_subheadline: 'Get the World\'s Most Accurate 60+ Page Kundali',
    hero_description: 'Unlock a deeply researched, personalized life report featuring 5-year detailed predictions. Delivered straight to your inbox and WhatsApp in exactly 48 hours. Available in English & Hindi.',
    hero_cta: 'Generate My Karma Kundali Now',
    hero_cta_price: 'Only ₹99',
    
    // Trust Badges
    trust_privacy: '100% Data Privacy',
    trust_secure: 'Secure Razorpay Checkout',
    trust_verified: 'Verified by Astro Avinash',
    
    // Problem Section
    problem_title: 'Is Career, Marriage, or Finance Keeping You Awake?',
    problem_description: 'Generic apps give you basic fluff. The Karma Kundali dives deep into your planetary alignments to give you clear timelines. No confusion, just crystal-clear guidance.',
    
    // Features Section
    features_title: 'What You Will Discover',
    features_subtitle: '60+ Pages of Deep Astrological Insights',
    
    feature_prediction_title: '5-Year Master Prediction',
    feature_prediction_desc: 'Month-by-month breakdown of your destiny',
    
    feature_career_title: 'Career & Wealth',
    feature_career_desc: 'Job/Business timing, promotions & financial peaks',
    
    feature_love_title: 'Love & Marriage',
    feature_love_desc: 'Partner compatibility and marriage timing',
    
    feature_doshas_title: 'Doshas & Remedies',
    feature_doshas_desc: 'Solutions for Kaal Sarp, Manglik & more',
    
    feature_language_title: 'Language Choice',
    feature_language_desc: 'Available in Hindi or English',
    
    // Authority Section
    authority_title: 'Crafted with Precision by',
    authority_name: 'Astro Avinash',
    authority_description: 'With years of deep Vedic research and a focus on real problem-solving, Astro Avinash has helped thousands find clarity in their lives through the ancient wisdom of Jyotish Shastra.',
    
    // Pricing Section
    pricing_title: 'Transparent Pricing',
    pricing_base: 'Karma Kundali Report',
    pricing_addon: 'Premium Numerology Abundance Report',
    pricing_addon_tag: 'Mandatory Add-on',
    pricing_total: 'Total',
    pricing_value: 'Value',
    pricing_you_pay: 'You Pay',
    
    // CTA Section
    cta_title: 'Your Destiny Won\'t Wait. Why Should You?',
    cta_description: 'Order now for delivery in exactly 48 hours.',
    cta_button: 'Claim My 60-Page Report Today',
    
    // Form Labels
    form_title: 'Enter Your Birth Details',
    form_step1: 'Personal Info',
    form_step2: 'Birth Details',
    form_step3: 'Contact',
    form_step4: 'Payment',
    
    form_full_name: 'Full Name',
    form_gender: 'Gender',
    form_gender_male: 'Male',
    form_gender_female: 'Female',
    form_gender_other: 'Other',
    
    form_dob: 'Date of Birth',
    form_tob: 'Time of Birth',
    form_pob: 'Place of Birth',
    
    form_email: 'Email Address',
    form_whatsapp: 'WhatsApp Number',
    form_language: 'Report Language',
    form_language_hindi: 'Hindi',
    form_language_english: 'English',
    
    form_next: 'Next',
    form_back: 'Back',
    form_submit: 'Proceed to Payment',
    
    // Success Page
    success_title: 'Payment Successful!',
    success_message: 'Your Karma Kundali is being prepared!',
    success_delivery: 'Delivery in exactly 48 hours to your Email and WhatsApp.',
    success_order_id: 'Order ID',
    success_home: 'Back to Home',
    
    // Footer
    footer_rights: '© 2026 Karma Kundali. All rights reserved.',
    footer_by: 'Powered by Astro Avinash',
  },
  hi: {
    // Navigation
    nav_home: 'होम',
    nav_about: 'हमारे बारे में',
    nav_features: 'विशेषताएं',
    nav_order: 'अभी ऑर्डर करें',
    
    // Hero Section
    hero_headline: 'अंदाज़ा लगाना छोड़ें, अपना भविष्य जानें।',
    hero_subheadline: 'प्राप्त करें दुनिया की सबसे सटीक 60+ पेज की कुंडली',
    hero_description: '5 साल की विस्तृत भविष्यवाणी के साथ अपने जीवन की गहराई से शोध की गई, व्यक्तिगत रिपोर्ट अनलॉक करें। ठीक 48 घंटे में आपके ईमेल और WhatsApp पर।',
    hero_cta: 'अभी मेरी कर्मा कुंडली बनाएं',
    hero_cta_price: 'सिर्फ ₹99',
    
    // Trust Badges
    trust_privacy: '100% डेटा सुरक्षा',
    trust_secure: 'सुरक्षित Razorpay चेकआउट',
    trust_verified: 'एस्ट्रो अविनाश द्वारा सत्यापित',
    
    // Problem Section
    problem_title: 'क्या करियर, शादी या पैसों की चिंता आपको सता रही है?',
    problem_description: 'आम ऐप्स केवल अधूरी जानकारी देते हैं। कर्मा कुंडली आपके ग्रहों का गहराई से विश्लेषण करके स्पष्ट समय सीमा (timelines) बताती है।',
    
    // Features Section
    features_title: 'आप क्या जानेंगे',
    features_subtitle: '60+ पेज की गहन ज्योतिषीय जानकारी',
    
    feature_prediction_title: '5-साल की मास्टर भविष्यवाणी',
    feature_prediction_desc: 'हर महीने का सटीक विश्लेषण',
    
    feature_career_title: 'करियर और धन',
    feature_career_desc: 'प्रमोशन और व्यापार का सही समय',
    
    feature_love_title: 'प्रेम और विवाह',
    feature_love_desc: 'जीवनसाथी और शादी का सटीक समय',
    
    feature_doshas_title: 'दोष और उपाय',
    feature_doshas_desc: 'काल सर्प, मांगलिक के अचूक उपाय',
    
    feature_language_title: 'भाषा चुनें',
    feature_language_desc: 'शुद्ध हिंदी या आसान अंग्रेजी',
    
    // Authority Section
    authority_title: 'पूरी सटीकता के साथ तैयार',
    authority_name: 'एस्ट्रो अविनाश',
    authority_description: 'वर्षों के गहन वैदिक अनुसंधान और वास्तविक समस्या-समाधान पर ध्यान केंद्रित करते हुए, एस्ट्रो अविनाश ने ज्योतिष शास्त्र की प्राचीन बुद्धि के माध्यम से हजारों लोगों को उनके जीवन में स्पष्टता प्राप्त करने में मदद की है।',
    
    // Pricing Section
    pricing_title: 'पारदर्शी मूल्य',
    pricing_base: 'कर्मा कुंडली रिपोर्ट',
    pricing_addon: 'प्रीमियम न्यूमेरोलॉजी एबंडेंस रिपोर्ट',
    pricing_addon_tag: 'अनिवार्य ऐड-ऑन',
    pricing_total: 'कुल',
    pricing_value: 'मूल्य',
    pricing_you_pay: 'आप देंगे',
    
    // CTA Section
    cta_title: 'आपकी किस्मत आपका इंतज़ार नहीं करेगी। आप क्यों करें?',
    cta_description: 'अभी ऑर्डर करें, ठीक 48 घंटे में डिलीवरी।',
    cta_button: 'आज ही मेरी 60-पेज की रिपोर्ट प्राप्त करें',
    
    // Form Labels
    form_title: 'अपना जन्म विवरण दर्ज करें',
    form_step1: 'व्यक्तिगत जानकारी',
    form_step2: 'जन्म विवरण',
    form_step3: 'संपर्क',
    form_step4: 'भुगतान',
    
    form_full_name: 'पूरा नाम',
    form_gender: 'लिंग',
    form_gender_male: 'पुरुष',
    form_gender_female: 'महिला',
    form_gender_other: 'अन्य',
    
    form_dob: 'जन्म तिथि',
    form_tob: 'जन्म का समय',
    form_pob: 'जन्म स्थान',
    
    form_email: 'ईमेल पता',
    form_whatsapp: 'WhatsApp नंबर',
    form_language: 'रिपोर्ट भाषा',
    form_language_hindi: 'हिंदी',
    form_language_english: 'अंग्रेज़ी',
    
    form_next: 'आगे',
    form_back: 'पीछे',
    form_submit: 'भुगतान करें',
    
    // Success Page
    success_title: 'भुगतान सफल!',
    success_message: 'आपकी कर्मा कुंडली तैयार हो रही है!',
    success_delivery: 'ठीक 48 घंटे में आपके ईमेल और WhatsApp पर डिलीवरी।',
    success_order_id: 'ऑर्डर ID',
    success_home: 'होम पर वापस जाएं',
    
    // Footer
    footer_rights: '© 2026 कर्मा कुंडली। सर्वाधिकार सुरक्षित।',
    footer_by: 'एस्ट्रो अविनाश द्वारा संचालित',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('hi');

  useEffect(() => {
    const savedLang = localStorage.getItem('karma_kundali_lang');
    if (savedLang) {
      setLanguage(savedLang);
    }
  }, []);

  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'hi' : 'en';
    setLanguage(newLang);
    localStorage.setItem('karma_kundali_lang', newLang);
  };

  const setLang = (lang) => {
    setLanguage(lang);
    localStorage.setItem('karma_kundali_lang', lang);
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
